import type { ConsentState } from '@redbrickmedia/duplex.user-identity'
import { queueCustomPatch } from '../ad-ops/assertive-yield/customDimensions'
import { CONSENT_STATE_DIMENSION } from '../ad-ops/assertive-yield/dimensions'
import { consentSnapshot, type ConsentDecision } from './consentGate'

export function currentConsentState(): ConsentState {
  return consentSnapshot()?.state ?? 'unknown'
}

/**
 * Not an identifier, so it is reported before a verdict exists — reporting uses it to
 * keep non-consented traffic out of split-test data.
 */
export function reportConsentState(decision: ConsentDecision): void {
  queueCustomPatch({ [CONSENT_STATE_DIMENSION]: decision.state })
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ consent_state: decision.state })
}
